export const VIDEO_DELETE_RESET = 'VIDEO_DELETE_RESET';
export const VIDEO_DELETE_SET_ERROR = 'VIDEO_DELETE_SET_ERROR';
export const VIDEO_DELETE_SET_DELETED = 'VIDEO_DELETE_SET_DELETED';
export const VIDEO_DELETE_TOGGLE_LOADING = 'VIDEO_DELETE_TOGGLE_LOADING';



// WEBPACK FOOTER //
// ./src/store/modules/video/delete/mutation_types.js